<template>
  <div ref="calendar"
       class="calendar"
       style="margin: auto; margin-top: 70px; max-width: 800px; width=80%;">
  </div>
</template>

<script>
import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import deLocale from '@fullcalendar/core/locales/de';

import bootstrapPlugin from '@fullcalendar/bootstrap';

import googleCalendarPlugin from '@fullcalendar/google-calendar';

export default {
  name: 'eventCalendar',
  data: () => {
    return {}
  },
  mounted(){
    let calendarEl = this.$refs.calendar
    let calendar = new Calendar(calendarEl, {
        height: 350,
        locale: deLocale,
        plugins: [ dayGridPlugin,
                   timeGridPlugin,
                   listPlugin,
                   googleCalendarPlugin,
                   bootstrapPlugin],
        defaultView: 'dayGridDay',
        selectable: true,
        eventColor: 'black',
        dateClick: function(info){
          console.log(info)
          info.dayEl.style.backgroundColor = 'blue';
        },
        header: {
          left: 'today',
          center: 'title',
          right: 'prev, next'
        },
        views: {
          dayGridDay: {
            type: 'listWeek',
            duration: { days: 1 },
            buttonText: '1 day'
          },
          dayGridWeek: {
            type: 'listWeek',
            duration: { days: 7 },
            buttonText: '7 days'
          }
        },
        googleCalendarApiKey: 'AIzaSyC66FBbWGRlcSDsaOM8mIOCyPWpXY9vpdE',
        events: {
          googleCalendarId: 'thav@red-action-records.de'
        }
    });

    calendar.render();
  }
}
</script>

<style lang="scss">
  @import '~@fullcalendar/bootstrap/main.css';
  @import '~@fullcalendar/core/main.css';
  @import '~@fullcalendar/daygrid/main.css';
  @import '~@fullcalendar/timegrid/main.css';
  @import '~@fullcalendar/list/main.css';

  .fc-day{
    background: rgba(0,0,0,0.3);
  }
  .fc th{
    background: rgba(0,0,0,0.3);
  }
  .fc-day-grid-container{
    background: rgba(0,0,0,0.3);
  }
  .fc-today{
    background: transparent !important;
  }
  fc-widget-header th{
    font-size: 1.5em;
  }
  .fc-view-container{
    text-align: center;
  }
  .fc-button-primary{
    background:#000;
    border-color: #fff;
    transition: all 0.3s;
  }
  .fc-button-primary:disabled{
    background:#000;
    border-color: #fff;
  }
  .fc-button-primary:not(:disabled):active, .fc-button-primary:not(:disabled).fc-button-active{
    background:#000;
  }
  .fc-content{
    display: block
  }
  span.fc-time{
    display: block;
  }
  .fc-day-grid-event .fc-content {
    white-space: normal;
  }
  span{
    font-size: 2.5em;
  }
  .fc-button-primary:hover{
    border-color: white;
    color: #7F0000;
  }
  span.fc-title:hover{
    tranition: color;
    transform: scale(1);
    color: #7F0000;
  }
  tr:first-child > td > .fc-day-grid-event {
    margin-top: 50px;
  }
  th.fc-future{
    background: transparent;
  }

  .fc-unthemed th,
  .fc-unthemed td,
  .fc-unthemed thead,
  .fc-unthemed tbody,
  .fc-unthemed .fc-divider,
  .fc-unthemed .fc-row,
  .fc-unthemed .fc-content,
  .fc-unthemed .fc-popover,
  .fc-unthemed .fc-list-view,
  .fc-unthemed .fc-list-heading td{
    border-color: #fff;
    border-width: 1px;
    border: none;
  }

</style>



// WEBPACK FOOTER //
// src/components/eventCalendar.vue